export default "__VITE_ASSET__Byo$_kn6__"